import { call, put, takeLatest } from 'redux-saga/effects';
import { LoginRequestsApi, ApiClient } from '@nutanix-api/iam-js-client';
import { getSessionId, logger } from '../utils';
import * as constants from '../constants';
import { PATH_URL } from '../constant';

let loginRequestsApi = new LoginRequestsApi();

/**
 * Saga to handle updating a login request.
 * @param {Object} action - The action object containing payload with extId and id.
 * @returns {void}
 */
export function* updateLoginRequestSaga(action) {
    const { loginRequestId, loginProviderId } = action.payload;
    const requestId = loginRequestId || getSessionId();

    try {
        if (!requestId) {
            throw new Error('Login request ID is required');
        }
        // Fetch login request by ID
        const { data } = yield call(
            [loginRequestsApi, loginRequestsApi.getLoginRequestById],
            requestId
        );

        const etagValue = ApiClient.getEtag(data);
        const responseData = data.getData();

        // Prepare the login request object
        const loginRequestObj = {
            clientId: responseData.clientId,
            responseType: responseData.responseType,
            scope: responseData.scope,
            redirectUri: responseData.redirectUri,
            extId: requestId,
            loginProviderId: loginProviderId,
        };

        // Update the login request
        yield call(
            [loginRequestsApi, loginRequestsApi.updateLoginRequestById],
            requestId,
            loginRequestObj,
            { 'If-Match': etagValue }
        );

        // Dispatch success action
        yield put({ type: constants.LOGIN_REQUEST_SUCCESS });

        // Redirect to the login page
        window.location.href = PATH_URL.INITIAL_LOGIN;
    } catch (error) {
        logger('updateLoginRequestSaga', error);

        // Dispatch failure action
        yield put({ type: constants.V4_API_FETCH_FAILED, error });
    }
}

/**
 * Saga to watch for login request update actions.
 * Triggers the updateLoginRequestSaga when LOGIN_REQUEST_UPDATE is dispatched.
 * @returns {void}
 */
export function* watchLoginRequestUpdate() {
    yield takeLatest(constants.LOGIN_REQUEST_UPDATE, updateLoginRequestSaga);
}
